import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {debounceTime, Subject, Subscription} from "rxjs";
import {ScreenSizeService} from "../services/screen-size.service";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-generic-search',
  templateUrl: './generic-search.component.html',
  styleUrls: ['./generic-search.component.css']
})
export class GenericSearchComponent implements OnInit, OnDestroy {
  @Input() placeholder: string = 'Search';
  @Input() debounceTime: number = 300;
  @Input() isMobile!: boolean;
  @Input() selectedResult!: string;
  @Output() inputTyped: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() searchChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() searchFormControl: FormControl<string> = new FormControl();

  private readonly searchSubject: Subject<string> = new Subject<string>();
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly screenSizeService: ScreenSizeService
  ) {
  }

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe({
      next: (isMobile: boolean) => {
        this.isMobile = isMobile;
      }
    });
    const searchSubject = this.searchSubject.pipe(
      debounceTime(this.debounceTime)
    ).subscribe({
      next: value => {
        this.searchChanged.emit(value);
      }
    });
    this.subscriptions.push(searchSubject);
    this.subscribeToSearchValueChanges();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  subscribeToSearchValueChanges(): void {
    this.searchFormControl.valueChanges.subscribe({
      next: (value: string) => {
        this.searchSubject.next(value);
      }
    })
  }
}
